import comparisonScrollController from './comparisonscrollcontroller.js';
import comparisonTable from './comparisontable.js';
import comparisontools from './comparisontools.js';
import productCards from './productcards.js';

export default function comparisonChart($container) {
    const $table = $container.querySelector('table');
    const table = comparisonTable($table);
    const products = productCards($table);

    const scroller = comparisonScrollController({
        $scrollarea: $container.querySelector('.compare-scroll-container'),
        $columns: [...$table.querySelector('tr').querySelectorAll('td, th')],
        $next: $container.querySelector('.control-scroll-next'),
        $previous: $container.querySelector('.control-scroll-previous')
    });

    comparisontools($container);

    products.onRemove(({ id }) => {
        table.removeById(id);
        scroller.forceUpdate();
    });

    const onRemove = (handler) => {
        if (typeof handler !== 'function') {
            throw new Error('comparisonChart onRemove requires a handler function.');
        }

        products.onRemove(({ id, $productCards }) => handler({
            id,
            isLastProduct: $productCards.length === 0
        }));
    };

    return {
        onRemove
    };
}